// HBO Master Studies
// University of Applied Sciences Master programs (advanced professional programs)

export const HBO_MASTER_STUDIES = {
  'Economie & Bedrijfskunde': {
    'Algemeen Management & Strategie': [
      'Master of Business Management',
      'Master of Strategic Management',
      'Executive MBA',
      'Strategy & Leadership',
      'MBA Leadership in Sustainability',
      'MBA Innovation & Leadership',
      'Master Circulaire Economie',
      'Business Engineering',
      'Interdisciplinary Business Professional',
      'Integraal Adviseur MKB',
      'Intergrale Bedrijfsvoering'
    ],
    'Ondernemerschap & Innovatie': [
      'Master in Consultancy and Entrepreneurship',
      'Management and Innovation',
      'Digital Driven Business',
      'Economische Transformatie',
      'Design Driven Innovation',
      'Imagineering, Master in Business Innovation from the Experience Perspective',
      'Applied Sustainability Management',
      'Sustainable Business Transition',
      'Action Learning MBA',
      'Business Sales'
    ],
    'Financieel Management & Control': [
      'Master in Controlling',
      'Master of Financial Management and Control',
      'Finance and Control'
    ],
    'Human Resource Management & Organisatie': [
      'Organisatie Coaching',
      'Human Resource Management (Master)',
      'Kwaliteitsmanagement',
      'Risico Management'
    ],
    'Project- & Eventmanagement': [
      'Project, Programma & Portfolio Management',
      'Projectmanagement',
      'Strategic Events Management'
    ],
    'Supply Chain & Facility Management': [
      'International Supply Chain Management',
      'Master in International Supply Chain Management',
      'Facility and Real Estate Management'
    ],
    'Toerisme, Hospitality & Leisure': [
      'International Hospitality and Service Management',
      'Leading Hotel Transformation',
      'Master of International Hospitality Management',
      'International Leisure, Tourism & Events Management',
      'Tourism Destination Management'
    ]
  },
  'Onderwijs & Opvoeding': {
    'Lerarenopleidingen': [
      'Leraar Geschiedenis',
      'Leraar Nederlands',
      'Leraar Fries',
      'Leraar Biologie',
      'Leraar Algemene Economie',
      'Leraar Wiskunde',
      'Leraar Frans',
      'Leraar Godsdienst',
      'Leraar Engels',
      'Leraar Duits',
      'Leraar Bedrijfseconomie',
      'Leraar Natuurkunde',
      'Leraar Aardrijkskunde',
      'Leraar Scheikunde',
      'Leraar Maatschappijleer'
    ],
    'Onderwijsinnovatie & -technologie': [
      'Leren Innoveren',
      'Onderwijs & Technologie',
      'Innovation & Leadership in Education',
      'Ontwerpen van Eigentijds Leren',
      'Toetsdeskundige',
      'Talentontwikkeling en Diversiteit',
      'Master Leiderschap in Onderwijs',
      'Leren en Innoveren',
      'Docent Hoger Gezondheidszorg Onderwijs'
    ],
    'Onderwijsmanagement & -beleid': [
      'Educational Leadership',
      'Master Educational Leadership',
      'Master Leiderschap en Innovatie Kind en Educatie',
      'Professioneel Meesterschap',
      'Passend Meesterschap'
    ],
    'Pedagogiek & Speciaal Onderwijs': [
      'Educational Needs',
      'Pedagogiek',
      'Taalbewust Leren'
    ]
  },
  'Kunst & Cultuur': {
    'Beeldende Kunst & Vormgeving': [
      'Master of Arts in Fine and Design',
      'Master Design',
      'Animatie',
      'Master Scientific Illustration',
      'Interieurarchitectuur',
      'Interior Architecture',
      'Type and Media'
    ],
    'Podiumkunsten & Muziek': [
      'Choreografie',
      'Performing Public Space',
      'Operationeel Leiderschap in Performing Arts',
      'Theater',
      'Performance Practices',
      'Opera',
      'Sonologie'
    ],
    'Media & Creatieve Industrie': [
      'Film',
      'DAS Creative Producing',
      'Crossover Creativity',
      'Applied Museum and Heritage Studies'
    ],
    'Filosofie & Theologie': [
      'Evangelical Theology',
      'Toegepaste Islamitische Theologie',
      'Toegepaste Filosofie'
    ]
  },
  'Gezondheid & Zorg': {
    'Fysiotherapie & Bewegingszorg': [
      'Fysiotherapie en Innovatie in Beweegzorg',
      'Orofaciale Fysiotherapie',
      'Sportfysiotherapie',
      'Fysiotherapie en Wijkgerichte Beweegzorg',
      'Master Kinderfysiotherapie',
      'Fysiotherapie in de Geriatrie',
      'Manuele Therapie',
      'Musculoskeletale Revalidatie',
      'Musculoskeletale Echografie voor Fysiotherapeuten',
      'Bekkenfysiotherapie'
    ],
    'Verpleegkunde & Gezondheidszorg': [
      'Advanced Nursing Practice',
      'Verpleegkunde Specialist/ANP GGZ',
      'GGZ-Verpleegkunde (GGZ-V)',
      'Critical Care',
      'Public Health and Health Equity',
      'Physician Assistant'
    ],
    'Innovatie & Leiderschap in Zorg': [
      'Health Innovation',
      'Gezondheidsinnovatie',
      'Innovatie in Zorg en Welzijn',
      'Advanced Health Informatics Practice',
      'Leiderschap voor Persoonsgerichte Zorg en Ondersteuning',
      'Healthy Ageing Professional'
    ],
    'Medische & Life Sciences': [
      'Medical Imaging/Radiation Oncology',
      'Molecular Life Sciences',
      'Neurorevalidatie'
    ]
  },
  'Techniek & ICT': {
    'ICT & Data Science': [
      'Management van IT',
      'Informatics',
      'Applied IT',
      'ICT: Software Engineering',
      'Applied Artificial Intelligence',
      'Business Information',
      'Cyber Security Engineering',
      'Responsible AI Innovation',
      'Computer Vision & Data Science',
      'Digital Design',
      'Applied Data Science',
      'Human-Centered Artificial Intelligence',
      'Digital Forensics',
      'Master of ICT and Business Innovation'
    ],
    'Engineering & Technologie': [
      'Polymer Engineering',
      'Master Digitale Technologie',
      'Robotics Systems Engineering',
      'System Design',
      'Next Level Engineering',
      'Applied Nanotechnology',
      'Innovatie Textile Development'
    ],
    'Bouw & Infra': [
      'Architectuur',
      'Stedenbouw',
      'Urban Technology',
      'Constructief Ontwerpen',
      'Master in Structural Engineering',
      'Master of Pipeline Technology'
    ],
    'Maritiem & Transport': [
      'Opleiding tot Registerloods: Master in Maritieme Piloting',
      'Shipping and Transport',
      'Maritime Innovations'
    ],
    'Games & Digitale Innovatie': [
      'Game Technology',
      'Serious Gaming',
      'Data-driven Design'
    ]
  },
  'Gedrag & Maatschappij': {
    'Psychologie & Coaching': [
      'Begeleidingskunde',
      'Toegepaste Psychologie voor Professionals',
      'Contextuele Benadering',
      'Speltherapie',
      'Ervaringsdeskundigheid'
    ],
    'Sociale Wetenschappen & Zorg': [
      'Social Work',
      'Master Systemisch Werken met Jeugd',
      'Vaktherapie',
      'Master Sport en Bewegingsonderwijs',
      'Jeugdzorg',
      'Human Development',
      'Community Development',
      'Health Care and Social Work'
    ],
    'Sport & Beweging': [
      'Sport Business & Leadership',
      'Sport en Beweeginnovatie',
      'Performance, Sport and Health',
      'Lichamelijke Opvoeding en Sportpedagogiek'
    ]
  },
  'Recht & Bestuur': {
    'Bestuur & Veiligheid': [
      'Master Urban Management',
      'Bestuurskunde',
      'Veiligheid en Digitalisering',
      'Master of Crisis and Public Order Management'
    ],
    'Recht & Juridische Dienstverlening': [
      'Bedrijfsrecht',
      'Toegepaste Recht',
      'Sociaal Juridische Expert',
      'Master Legal Management'
    ],
    'Algemeen Recht & Rechtsgeleerdheid': [
      'Nederlands recht',
      'Rechtsgeleerdheid',
      'Privaatrecht',
      'Publiekrecht',
      'Rechtwetenschappelijk Onderzoek'
    ],
    'Internationaal & Europees Recht': [
      'International Laws',
      'International and European Law',
      'International Business Law',
      'International Commercial Law',
      'Globalisation and Law',
      'European Private Law',
      'European Law in a Global Context',
      'Public International Law',
      'International Tax Law',
      'International and European Tax Law',
      'Advanced Studies in International Civil and Commercial Law',
      'Advanced Studies in Public International Law',
      'Advanced Studies in European and International Business Law',
      'Advanced Studies in European and International Human Rights Law'
    ],
    'Ondernemingsrecht & Financieel Recht': [
      'Ondernemingsrecht',
      'Onderneming en recht',
      'Commercial Law',
      'Advanced Studies in Law and Finance',
      'Law and Economics'
    ],
    'Arbeidsrecht & Sociaal Recht': [
      'Arbeidsrecht',
      'Recht en Arbeid',
      'Sociaal Recht en Sociale Politiek'
    ],
    'Fiscaal & Notarieel Recht': [
      'Fiscaal Recht',
      'Notarieel Recht'
    ],
    'Technologie, Privacy & Intellectueel Eigendom': [
      'Law and Technology',
      'IT-recht',
      'Advanced Master Intellectual Property Law and Knowledge Management LL.M.',
      'Advanced Studies in Law and Digital Technologies',
      'Gegevensbescherming en Privacyrecht'
    ],
    'Klimaat-, Energie- & Ruimterecht': [
      'Energy and Climate Law',
      'Advanced Master in Energy Law',
      'Advanced Studies in Air and Space Law'
    ],
    'Strafrecht, Criminologie & Veiligheid': [
      'Criminologie',
      'Forensische Criminologie',
      'Global Criminal Law',
      'International Criminal Law',
      'International Crimes, Conflict and Criminology',
      'Criminaliteit en Rechtshandhaving',
      'Forensica, Criminologie en Rechtspleging',
      'Law and Politics of International Security'
    ],
    'Bestuurskunde & Openbaar Bestuur': [
      'Bestuurskunde',
      'Public Administration',
      'Recht en Bestuur',
      'Publiek Management',
      'Management Publieke Sector',
      'Executive Master of Public and Non-profit Management',
      'Research in Public Administration and Organizational Science'
    ],
    'Beleid & Organisatie': [
      'Public Policy and Human Development',
      'Erasmus Mundus Master\'s Program in Public Policy',
      'International Public Management and Public Policy',
      'Conflict Resolution and Governance',
      'Beleid, Communicatie en Organisatie',
      'Sustainability Science, Policy and Society',
      'Governance of Sustainability',
      'Organization and Management Studies'
    ],
    'Internationale Betrekkingen & Diplomatie': [
      'Internationale betrekkingen',
      'International Relations and Diplomacy'
    ],
    'Specialisaties in Recht': [
      'Advanced Studies in International Children\'s Rights',
      'Advanced Studies in International Dispute Settlement and Arbitration',
      'Advanced LLM in Technology Governance',
      'Mater of Science in Policing',
      'Togamaster',
      'Jeugdrecht',
      'Aansprakelijkheid en verzekering'
    ],
    'Management & Leiderschap binnen Recht en Bestuur': [
      'Executive Master of Management and Organization',
      'Executive Master of Management in Education'
    ]
  },
  'Taal & Communicatie': {
    'Communicatie & Media': [
      'Professional Master in Media Innovation',
      'International Communication Management',
      'International Communication',
      'Strategische Communicatie',
      'Content & Media Strategy'
    ]
  }
};

export default HBO_MASTER_STUDIES;